import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const CommentIcon = ({
  viewBox, color, fillOpacity, ...props
}) => (
  <svg
    {...helpers.getSvgDimensionsProps(props)}
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...{ viewBox }}
  >
    <path
      fill={color}
      d="M6 11.5C5.86739 11.5 5.74021 11.4473 5.64645 11.3536C5.55268 11.2598 5.5 11.1326 5.5 11V9.5H3.5C3.23478 9.5 2.98043 9.39464 2.79289 9.20711C2.60536 9.01957 2.5 8.76522 2.5 8.5V3.5C2.5 3.23478 2.60536 2.98043 2.79289 2.79289C2.98043 2.60536 3.23478 2.5 3.5 2.5H10.5C10.7652 2.5 11.0196 2.60536 11.2071 2.79289C11.3946 2.98043 11.5 3.23478 11.5 3.5V8.5C11.5 8.76522 11.3946 9.01957 11.2071 9.20711C11.0196 9.39464 10.7652 9.5 10.5 9.5H8.45L6.6 11.355C6.5 11.45 6.375 11.5 6.25 11.5H6ZM6.5 8.5V10.04L8.04 8.5H10.5V3.5H3.5V8.5H6.5ZM1.5 7.5H0.5V1.5C0.5 1.23478 0.605357 0.98043 0.792893 0.792893C0.98043 0.605357 1.23478 0.5 1.5 0.5H9.5V1.5H1.5V7.5Z"
    />
  </svg>
);

CommentIcon.propTypes = {
  viewBox: string,
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

CommentIcon.defaultProps = {
  fillOpacity: 0.4,
  viewBox: '0 -1 13 14',
  ...helpers.getDefaultIconDimensionsProps(19, 16),
};

export default CommentIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/comment.js